import { Scaffold } from 'layouts';
import { UnloadingOrders } from 'components/Pages/ScheduledReports';

export const UnloadingOrdersPage = () => (
  <Scaffold>
    <UnloadingOrders />
  </Scaffold>
);
